module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright",
    attrs: {
      "id": "cop"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_vm._v("Copyright © 1994 by Stackpole Books")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Published by"), _c('br'), _vm._v("STACKPOLE BOOKS"), _c('br'), _vm._v("5067 Ritter Road"), _c('br'), _vm._v("Mechanicsburg, PA 17055"), _c('br'), _c('a', {
    staticClass: "pubhlink",
    attrs: {
      "href": "http://www.stackpolebooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.stackpolebooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved, including the right to reproduce this book or portions thereof in any form or by any means, electronic or mechanical, including photocopying, recording, or by any information storage and retrieval system, without permission in writing from the publisher. All inquiries should be addressed to Stackpole Books, 5067 Ritter Road, Mechanicsburg, PA 17055.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("20 19 18 17 16 15 14 13 12 11")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("First Edition")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Cover design by Mark Olszewski"), _c('br'), _vm._v("Back cover map by Sandra M. Blair"), _c('br'), _vm._v("Cover photograph by Mike Warren. From Millbrook Mountain"), _c('br'), _vm._v("   in the Delaware Water Gap, New Jersey."), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('strong', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Luxenberg, Larry."), _c('br'), _vm._v("   Walking the Appalachian Trail / Larry Luxenberg; photographs by Mike Warren. — 1st ed."), _c('br'), _vm._v("      p.   cm."), _c('br'), _vm._v("   Includes bibliographical references."), _c('br'), _vm._v("   ISBN 0-8117-3095-6"), _c('br'), _vm._v("   1. Hiking—Appalachian Trail. 2. Appalachian Trail—Description and travel. I. Title."), _c('br'), _vm._v("GV199.42.A68L68 1995                                               94-26376"), _c('br'), _vm._v("796.5′1′0974—dc20                                                            CIP")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN 978-0-8117-3095-2")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b68f3d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780811744010_epub_cop_r1.vue
// module id = 60
// module chunks = 0